<div [hidden]="isEditing" [ngClass]="adquirente && adquirente.Padrao ? 'cedente padrao card col-md-12' : 'cedente card col-md-12'">
  <div class="row radio-padrao">
    <input (change)="adquirentePadrao()" [checked]="adquirente.Padrao" id={{adquirente.AdquirenteId}} type="radio" class="styled-radio">
    <label for={{adquirente.AdquirenteId}}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <title></title>
        <polyline points="4 8 7 11 12 6" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      </svg>
    </label>

    <span *ngIf="adquirente.Padrao">Este é seu adquirente atual</span>
  </div>

  <form class="row">
      <div class="col-sm-2">
        <div *ngIf="adquirente.Nome === 'CieloSandBox' || adquirente.Nome === 'Cielo'" class="logo-adquirente">
            <img src="/assets/img/logo-cielo.svg">
        </div>
        <div *ngIf="adquirente.Nome === 'StoneSandBox' || adquirente.Nome === 'Stone'" class="logo-adquirente">
            <img src="/assets/img/logo-stone.svg">
        </div>
        <div *ngIf="adquirente.Nome === 'Rede'" class="logo-adquirente">
            <img src="/assets/img/logo-rede.png">
        </div>
      </div>

    <div class="col-sm-8">
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group" appAnimate="fadeIn" delay="300">
            <label for="" class="control-label">Nome</label>
            <h5 class="mar-no">{{adquirente.Nome}}</h5>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group" appAnimate="fadeIn" delay="300">
            <label for="" class="control-label">Merchant ID</label>
            <h5 class="mar-no">{{adquirente.GatewayId}}</h5>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group" appAnimate="fadeIn" delay="300">
            <label for="" class="control-label">Merchant Key</label>
            <h5 class="mar-no">{{adquirente.GatewayKey}}</h5>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div [hidden]="!isEditing" class="card col-md-12 animate-card-down-adquirente">
  <form (ngSubmit)="submit($event)">
    <div class="col-md-10">
        <div class="row text-left">
          <div class="col-sm-3">
            <div class="form-group">
              <div class="dropdown">
                <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                  <span *ngIf="(adquirente && !adquirente.Nome) || !adquirente">Selecione um adquirente</span>
                  <img *ngIf="adquirente && adquirente.Nome && adquirente.Nome === 'Cielo' || adquirente.Nome === 'CieloSandBox'" src="/assets/img/logo-cielo.svg">
                  <img *ngIf="adquirente && adquirente.Nome && adquirente.Nome === 'Rede'" src="/assets/img/logo-rede.png">
                  <span class="caret"></span>
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                  <li>
                    <a (click)="selectAdquirente('Cielo')">
                      <img src="/assets/img/logo-cielo.svg">
                    </a>
                 </li>
                  <li>
                    <a (click)="selectAdquirente('Rede')">
                      <img src="/assets/img/logo-rede.png">
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="row text-left">
          <div class="col-sm-10">
            <div class="form-group">
              <label for="" class="control-label">Merchant ID</label>
              <input class="form-control" type="text" [(ngModel)]="adquirente.GatewayId" name="CodigoConvenio">
            </div>
          </div>
        </div>

        <div class="row text-left">
          <div class="col-sm-10">
            <div class="form-group">
              <label for="" class="control-label">Merchant Key</label>
              <input class="form-control" type="text" [(ngModel)]="adquirente.GatewayKey" name="Descrição">
            </div>
          </div>
        </div>
    </div>

    <div class="col-md-2">
      <button [ngClass]="isLoading ? 'btn btn-grey loading pull-right' : 'btn btn-grey pull-right'">Salvar</button>
    </div>
  </form>
</div>
